/* global VERBOSE */
/* eslint-disable no-console */

const isUndefined_ = require('lodash/isUndefined')

function isPromise(something) {
  return something && typeof something.then === 'function'
}

function handleSuccess(explicitName, result) {
  const verboseArgs = isUndefined_(result)
    ? [`[wix-dataset.${explicitName}] returned`]
    : [
        `[wix-dataset.${explicitName}] returned with (`,
        JSON.stringify(result),
        `)`
      ]
  console.verbose(...verboseArgs)
}

const callbacksRegistration = [
  'onReady',
  'onError',
  'onBeforeSave',
  'onAfterSave',
  'onCurrentIndexChanged',
  'onItemValuesChanged'
]
const verboseWrapper = (func, explicitName) => (...args) => {
  if (callbacksRegistration.includes(explicitName)) {
    console.verbose(`[${explicitName} callback registered] on wix-dataset`)
    return func(...args)
  }

  const verboseArgs =
    args.length === 0
      ? [`[wix-dataset.${explicitName}] called`]
      : [
          `[wix-dataset.${explicitName}] called with (`,
          JSON.stringify(args),
          `)`
        ]
  console.verbose(...verboseArgs)

  const result = func(...args)
  if (isPromise(result)) {
    return result.then(result => {
      handleSuccess(explicitName, result)
      return result
    })
  }
  handleSuccess(explicitName, result)
  return result
}

const verboseIfNeeded = (func, explicitName) =>
  VERBOSE ? verboseWrapper(func, explicitName) : func

const verboseEvent = (eventName, eventData) => {
  if (!VERBOSE) {
    return
  }

  const verboseArgs = isUndefined_(eventData)
    ? [`[${eventName} event] triggered on wix-dataset`]
    : [
        `[${eventName} event] triggered on wix-dataset with (`,
        JSON.stringify(eventData),
        `)`
      ]
  console.verbose(...verboseArgs)
}

module.exports.verboseWrapper = verboseWrapper
module.exports.verboseIfNeeded = verboseIfNeeded
module.exports.verboseEvent = verboseEvent



// WEBPACK FOOTER //
// ./dataset-api/verbosity.js